import $ from 'jquery';

function labelActive(el) {
  let inputId = el.attr('id');
  $(`label[for=${inputId}]`).addClass('active');
}

function labelInActive(el) {
  let inputId = el.attr('id');
  if(!el.val()) $(`label[for=${inputId}]`).removeClass('active');
  if (el.val() === '(___) ___-____' ) {
    $(`label[for=${inputId}]`).removeClass('active');
  }
}

function initLabel() {
    if ($('.checkout-customer-form').length > 0) {
        $(document).on('focus','input', function() {
          labelActive($(this));
        });

        $(document).on('focusout','input', function() {
          labelInActive($(this));
        });

        $(document).on('focus','textarea', function() {
          labelActive($(this));
        });

        $(document).on('focusout','textarea', function() {
          labelInActive($(this));
        });
    }
}

export {
    initLabel,
}
